import styled from 'styled-components'

interface Props {
  open: boolean
  children: JSX.Element
}

const Content = styled.div<Props>`
  background-color: ${(props) => props.theme.customPalette.light};
  display: flex;
  justify-content: center;
  margin-left: ${(props) => (props.open ? '212px' : '80px')};
  margin-top: 80px;
  padding: 0;
  width: 100%;
`

export default function ContentContainer({ open, children }: Props): JSX.Element {
  return <Content open={open}>{children}</Content>
}
